import type { CollectionModelFieldSubFormInstance } from '@ikegps/core-shared';
import { action } from 'mobx';
import { ImageButton } from '../../../components/button/image.button';
import { MaterialIcon } from '../../../components/icon/icons';
import { ModalService } from '../../../components/modal/modal.service';
import { T, Translate } from '../../../i18n';
import type { MithrilVNode } from '../../../mithril';
import { Services } from '../../../services';
import { CurrentState } from '../../../state/page.state';
import { TopologicalEditorCollectionEditCtrl } from '../../../page/topological.editor.page/topological.editor.collection.edit.ctrl';
import { TopologicalPointCollectionCache } from '../../topological.editor.map/point.collection.cache';
import type { ICollectionViewController } from '../collection.view.ctrl.interface';

export class SubformRemoveTool {
	static view(ctrl: ICollectionViewController, collection: CollectionModelFieldSubFormInstance): MithrilVNode {
		return ImageButton.view(MaterialIcon.DELETE, {
			title: T.COLLECTION_EDIT_DELETE_SUBFORM,
			titleAttrs: { title: collection.schema.displayName },
			onclick: (e: Event) => SubformRemoveTool.removeSubFormInstance(ctrl, e, collection),
			testId: 'subform-remove',
		});
	}

	private static async removeSubFormInstance(
		ctrl: ICollectionViewController,
		e: Event,
		c: CollectionModelFieldSubFormInstance
	) {
		e.stopPropagation();

		const response = await ModalService.open({
			title: Translate(T.SUBFORM_REMOVE_TITLE, { title: c.formTitle }),
			content: Translate(T.SUBFORM_REMOVE_CONFIRM, { title: c.schema.displayName }),
			okName: T.SUBFORM_REMOVE_REMOVE,
			hasCancel: true,
		});

		if (response.ok) {
			this.doRemoveSubFormInstance(ctrl, c);
		}
	}

	@action private static doRemoveSubFormInstance(
		ctrl: ICollectionViewController,
		c: CollectionModelFieldSubFormInstance
	) {
		CurrentState.cancelInteractions();

		c.parent.Mutator.remove(c.instanceId);

		// Update current capture if capture was removed with form (we dont update this if we are in TE)
		const captureIds = Services.Collection.getCaptureIds(c.collection);
		if (captureIds.indexOf(CurrentState.inspectedCaptureId) === -1 && !TopologicalEditorCollectionEditCtrl.is(ctrl)) {
			CurrentState.inspectedCaptureId = null;
		}

		if (TopologicalEditorCollectionEditCtrl.is(ctrl)) {
			TopologicalPointCollectionCache.dropCollectionVectors(c.collection.revision);
		}

		Services.Analytics.trackEvent(Services.Analytics.EventCategory.Mutate, 'subform:delete', c.instanceId);
	}
}
